// extracted by mini-css-extract-plugin
module.exports = {"sent":"PupilsStep_sent__3fsKa"};